var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MonitorLayoutTemplate", {
    attrs: {
      table_title: _vm.table_title,
      is_show_chart_dialog: _vm.is_show_chart_dialog
    },
    scopedSlots: _vm._u([
      {
        key: "datetime",
        fn: function() {
          return [
            _c("QpeDatetime", {
              attrs: {
                props_date: _vm.date,
                props_time: _vm.time,
                name: _vm.default_value
              },
              on: {
                "update-time": _vm.update_time,
                "change-parent-date-time": _vm.change_parent_date_time
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "description",
        fn: function() {
          return [
            _c("SignsCalculator", { attrs: { data: _vm.sign_data } }),
            _vm._v(" "),
            _vm.table_data.length
              ? _c("MapDisplaySwitch", {
                  attrs: {
                    table_id: _vm.default_value,
                    table_data: _vm.immutable_table_data
                  }
                })
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "signs",
        fn: function() {
          return [
            _vm.sign_data
              ? _c("MonitorSigns", { attrs: { data: _vm.sign_data } })
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "data_table",
        fn: function(slot_props) {
          return [
            _c("QpeDatatable", {
              attrs: {
                data: _vm.table_data,
                headers: _vm.header,
                name: _vm.default_value,
                error_text: _vm.error_text,
                search: slot_props.search,
                should_draw_diagram_header: _vm.should_draw_diagram_header,
                show_download_pdf_btn: true,
                should_display_info_header_key_value:
                  _vm.should_display_info_header_key_value,
                generate_tooltop_display_info:
                  _vm.generate_tooltop_display_info_for_table,
                should_show_raw_html_header: _vm.should_show_raw_html_header,
                is_show_chart_dialog_parent: _vm.is_show_chart_dialog
              },
              on: {
                "update-time": _vm.update_time,
                "change-parent-date-time": _vm.change_parent_date_time,
                "open-chart": _vm.assign_chart_component,
                "update:is_show_chart_dialog_parent": function($event) {
                  _vm.is_show_chart_dialog = $event
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "table_description",
                    fn: function() {
                      return [
                        _c("div", { staticClass: "explanation" }, [
                          _c("span", [_vm._v("1. 「--」 表示該欄位無資料。")]),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v("2. 此表之路段雨量來自定量降雨估計(QPE)，")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "為結合雷達與雨量站觀測資料的估計值，敬請謹慎使用。"
                            )
                          ])
                        ])
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "diagram_dialog",
                    fn: function(ref) {
                      var close_dialog = ref.close_dialog
                      return [
                        _vm.history_data_loaded && _vm.is_show_chart_dialog
                          ? [
                              _c("MonitorQpe", {
                                attrs: {
                                  timeseries_data: _vm.history_data,
                                  default_variable: _vm.qpe_history_option
                                },
                                on: { "close-chart-dialog": close_dialog }
                              })
                            ]
                          : _vm._e()
                      ]
                    }
                  }
                ],
                null,
                true
              )
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }